module.exports = __webpack_public_path__ + "img/intro-title-nl.9f49d376.png";